import { render, staticRenderFns } from "./BaseStatusForm.vue?vue&type=template&id=1dd2895b&"
import script from "./BaseStatusForm.vue?vue&type=script&lang=js&"
export * from "./BaseStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports